import React from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUserCircle, faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
// import PasswordStrengthBar from 'app/shared/layout/password/password-strength-bar-custom';
import PasswordStrengthBar from '../../../../../app/shared/layout/password/password-strength-bar-custom';
import { colors } from '../../../../../app/config/color';
import { Authenticator_Type, Authenticator_Status, APP_LOCAL_DATE_FORMAT, ACR_VALUES } from '../../../../../app/config/constants';
import moment from 'moment';

export interface ItemGroupProps {
  auth: any;
  resetPassword: Function;
  deleteAuth: Function;
  handleActive: Function;
  sendOtp: Function;
  count: any;
  // userProfile: any;
}

export interface ItemGroupState {
  modalShow: boolean;
  id: Int16Array;
  name: String;
}

export default class ItemGroup extends React.Component<ItemGroupProps, ItemGroupState> {
  state: ItemGroupState = {
    modalShow: false,
    id: null,
    name: ''
  };
  confirm = (id, name) => {
    event.preventDefault();
    this.setState(prevState => ({
      modalShow: !prevState.modalShow,
      id: id,
      name: name
    }));
  };

  handleDelete = () => {
    const { id } = this.state;
    if (id) {
      this.props.deleteAuth(id);
    }
    this.toggle();
  };

  handleSetActive = (event, id) => {
    // event.preventDefault();
    this.props.handleActive(id);
  };

  resetPassword = () => {
    // e.preventDefault();
    this.props.resetPassword();
  };

  toggle = () => {
    this.setState(prevState => ({
      modalShow: !prevState.modalShow
    }));
  };

  sendOtp = value => {
    this.props.sendOtp(value);
  };

  renderTextContent = auth => {
    switch (auth.type) {
      case Authenticator_Type.SMS:
        return (
          <span style={{ color: '#868e96' }}>
            {auth.phone}
            {/*{auth.phone + ' - '}*/}
            {/*{auth.status !== Authenticator_Status.ACTIVE ? (*/}
            {/*  <label id="linkStyle" className="font-weight-bold" onClick={e => this.handleSetActive(e, auth.id)}>*/}
            {/*    Đặt làm mặc định*/}
            {/*  </label>*/}
            {/*) : (*/}
            {/*  'Mặc định'*/}
            {/*)}*/}
          </span>
        );
      case Authenticator_Type.EMAIL:
        return <span style={{ color: '#868e96' }}>{auth.phone}</span>;
      case Authenticator_Type.PKI:
        return (
          <span style={{ color: '#868e96' }}>
            {auth.phone +
              '    ' +
              moment(auth.effectDate).format(APP_LOCAL_DATE_FORMAT) +
              ' - ' +
              moment(auth.expiredDate).format(APP_LOCAL_DATE_FORMAT)}
          </span>
        );
      case Authenticator_Type.USB:
        return (
          <span style={{ color: '#868e96' }}>
            {auth.subjectCN
              ? auth.subjectCN
              : '' +
                '    ' +
                moment(auth.effectDate).format(APP_LOCAL_DATE_FORMAT) +
                ' - ' +
                moment(auth.expiredDate).format(APP_LOCAL_DATE_FORMAT)}
          </span>
        );
      case Authenticator_Type.SMART_CA:
        return (
          <span style={{ color: '#868e96' }}>
            {auth.subjectCN
              ? auth.subjectCN
              : '' +
                '    ' +
                moment(auth.effectDate).format(APP_LOCAL_DATE_FORMAT) +
                ' - ' +
                moment(auth.expiredDate).format(APP_LOCAL_DATE_FORMAT)}
          </span>
        );
      default:
        return null;
    }
  };

  render() {
    const { auth, count } = this.props;
    // const { auth } = this.props;
    return (
      <div>
        <Modal isOpen={this.state.modalShow} toggle={this.toggle} backdrop="static" centered={window.location === window.parent.location}>
          <ModalHeader toggle={this.toggle}>
            <h3 className="font-weight-bold">Thông Báo</h3>
          </ModalHeader>
          <ModalBody className="padding-modal-body">
            <Row style={{ padding: '20px' }}>
              <h5>
                <span>Bạn có chắc chắn muốn xóa {this.state.name}?</span>
              </h5>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button className="btn-register" onClick={this.handleDelete}>
              Ok
            </Button>{' '}
            <Button className="btn-register-white" onClick={this.toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        <Row style={{ flex: 1, flexDirection: 'row' }}>
          <Col style={{ flex: 1 }} />

          <Col style={{ flex: 7 }}>
            <div>
              <h5 className="font-weight-bold">{auth.name}</h5>
              <span style={{ color: '#868e96' }}>{this.renderTextContent(auth)}</span>
              {/*<PasswordStrengthBar number={auth.loA} />*/}
            </div>
          </Col>
          <Col style={{ flex: 2 }} className="text-center">
            {auth.type === Authenticator_Type.PASSWORD ? null : // <Button className="btnDelete" onClick={() => this.resetPassword()}>
            //   <FontAwesomeIcon icon={faPencilAlt} color="#4D9235" />
            //   &nbsp;&nbsp; Sửa
            // </Button>
            auth.type === Authenticator_Type.TOTP ? null : (
              <Button
                className="btnDelete"
                onClick={() => this.sendOtp(auth.phone)}
                // disabled={
                //   (count && count === 1) || (auth.status === Authenticator_Status.ACTIVE && auth.type === Authenticator_Type.SMS)
                // }
              >
                <FontAwesomeIcon icon={faPencilAlt} color="#4D9235" />
                &nbsp;&nbsp; Sửa
              </Button>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
